// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { AppProvider } from './contexts/AppContext';
import RequireAuth from './components/utils/RequireAuth';
import RequireSubscription from './components/utils/RequireSubscription';
import Layout from './components/commons/Layout';

import Login from './pages/Login';
import ForgotPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPwd';
import Activation from './pages/Activation';

import Dashboard from './pages/Dashboard';
import HomeLayout from './pages/HomeLayout';
import HomeQuickLink from './pages/HomeQuickLink';
import ServiceLayout from './pages/ServiceLayout';
import Content from './pages/Content';
import SettingBrandStyle from './pages/SettingBrandStyle';
import SettingContact from './pages/SettingContact';
import SettingDisplayCollateral from './pages/SettingDisplayCollateral';
import SettingThemeColor from './pages/SettingThemeColor';
import Map from './pages/Map';
import Analytics from './pages/Analytics';
import Notifications from './pages/Notifications';
import AddUser from './pages/AddUser';
import Detail from './pages/Detail.js';
import AdsSettings from './pages/AdsSettings.js';
import AdsContent from './pages/AdsContent.js';
import TsVenueContent from './pages/TsVenueContent.js';
import TsVenueLanding from './pages/TsVenueLanding/TsVenueLanding.js';
import TsAdvLanding from './pages/TsAdvLanding/TsAdvLanding.js';
import TsAdvContent from './pages/TsAdvContent.js';
import TsDetail from './pages/TsDetail.js';
import Billing from './pages/Billing.js';
import ImportedEvents from './pages/ImportedEvents.js';
import TsVenueAnalytics from './pages/TsVenueAnalytics.js';

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Routes>

          <Route path="/login" element={<Login />} />
          <Route path="/forgetpwd" element={<ForgotPassword />} />
          <Route path="/resetpwd" element={<ResetPassword />} />
          <Route path="/activation" element={<Activation />} />

          <Route element={<RequireAuth><RequireSubscription><Layout /></RequireSubscription></RequireAuth>}>

            <Route index element={<Dashboard />} />

            {/* Home */}
            <Route path="home/layout" element={<HomeLayout />} />
            <Route path="home/quick-links" element={<HomeQuickLink />} />

            {/* Services */}
            <Route path="services/layout" element={<ServiceLayout />} />
            <Route path="services/content" element={<Content />} />
            <Route path="/detail/:id" element={<Detail />} />
            <Route path="/detail/:id/add" element={<Detail />} />
            <Route path="/detail/:id/add/list" element={<Detail />} />
            <Route path="/detail/:id/add/entry" element={<Detail />} />

            {/* Settings */}
            <Route path="settings/brand-style" element={<SettingBrandStyle />} />
            <Route path="settings/theme" element={<SettingThemeColor />} />
            <Route path="settings/contact" element={<SettingContact />} />
            <Route path="settings/display-collateral" element={<SettingDisplayCollateral />} />

            {/* Others */}
            <Route path="map" element={<Map />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="user/add-user" element={<AddUser />} />

            {/* Ads */}
            <Route path="ads-settings" element={<AdsSettings />} />
            <Route path="ads-content" element={<AdsContent />} />

            <Route path='ts/venue/branding' element={<TsVenueLanding />} />
            <Route path='ts/venue/content' element={<TsVenueContent />} />
            <Route path='ts/venue/analytics' element={<TsVenueAnalytics />} />
            <Route path='ts/venue/imported-events' element={<ImportedEvents />} />
            <Route path="ts/detail/:id" element={<TsDetail />} />
            <Route path="ts/detail/:id/add" element={<TsDetail />} />
            <Route path="ts/detail/:id/add/list" element={<TsDetail />} />
            <Route path="ts/detail/:id/add/entry" element={<TsDetail />} />
            <Route path='ts/adv/media' element={<TsAdvLanding />} />
            <Route path='ts/adv/content' element={<TsAdvContent />} />

            <Route path='billing' element={<Billing />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AppProvider>
    </BrowserRouter>
  );
}


